import React, { useState } from 'react';

interface LoginViewProps {
  onSubmit: (email: string, password: string) => Promise<void>;
  onSwitchToCreateAccount: () => void;
  onForgotPassword: () => void;
  isLoading: boolean;
}

const LoginView: React.FC<LoginViewProps> = ({
  onSubmit,
  onSwitchToCreateAccount,
  onForgotPassword,
  isLoading
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit(email, password);
  };

  return (
    <>
      <div className="text-sm text-gray-600 mb-2">
        Entre com sua conta da DIO
      </div>

      <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
        <div>
          <label htmlFor="login-email" className="block text-xs font-semibold text-gray-700 mb-1">E-mail</label>
          <div className="relative">
            <input
              id="login-email"
              type="email"
              placeholder="seu@email.com"
              className="input pr-10"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
            {email && (
              <button 
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2" 
                onClick={() => setEmail('')}
                aria-label="Limpar campo de email"
              >
                <svg className="w-5 h-5 text-gray-400 hover:text-red-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            )}
          </div>
        </div>

        <div>
          <label htmlFor="login-password" className="block text-xs font-semibold text-gray-700 mb-1">Senha</label>
          <div className="relative">
            <input
              id="login-password"
              type="password"
              placeholder="********"
              className="input pr-10"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
            {password && (
              <button 
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2" 
                onClick={() => setPassword('')}
                aria-label="Limpar campo de senha"
              >
                <svg className="w-5 h-5 text-gray-400 hover:text-red-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            )}
          </div>
          <div className="flex justify-end mt-1">
            <button 
              type="button" 
              onClick={onForgotPassword} 
              className="text-sm text-gray-700 hover:text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50 flex items-center"
              aria-label="Esqueci minha senha"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
              Esqueci minha senha
            </button>
          </div>
        </div>

        <button
          type="submit"
          className="w-full btn btn-primary"
          aria-label="Entrar"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleSubmit(e);
            }
          }}
          disabled={isLoading}
        >
          {isLoading ? 'Entrando...' : 'Entrar'}
        </button>

        <div className="text-center text-sm text-gray-600 mt-4">
          Não tem conta?{' '}
          <button 
            type="button" 
            onClick={onSwitchToCreateAccount} 
            className="text-primary font-semibold hover:underline focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50" 
            aria-label="Criar uma conta" 
            tabIndex={0} 
            onKeyDown={(e) => { 
              if (e.key === 'Enter' || e.key === ' ') { 
                onSwitchToCreateAccount(); 
              } 
            }}
          >
            Crie uma agora
          </button>
        </div>
      </form>
    </>
  );
};

export default LoginView;
